import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=85fb1042&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=85fb1042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb1042",
  null
  
)

export default component.exports